import React from 'react'

import BoatNMEAScreen from './BoatNMEAScreen'

export default {
  id : 'siren.boat.nmea.GroupScreen',
  matches : { client : 'ItemScreen', path : 'boat', objectType : 'boat' },
  exact : true,
  path : '/p/:persona/boat/:boatId/nmea',
  default : false,
  render : ctx => React.createElement( BoatNMEAScreen, ctx )
  
}
